import { PersonnelOption, SearchPersonnelResponse } from "../dtos/Tmd.dtos";

/**
 * Creates a memoized personnel search function that can be used with async select components
 * @param defaultOption Optional default personnel object to show when input is empty
 * @returns A memoized async function that searches for personnel
 */
export const createPersonnelSearchLoader = (
    defaultOption?: PersonnelOption | PersonnelOption[] | null
) => {
    const cache: Record<string, PersonnelOption[]> = {};
    
    return async (inputValue: string): Promise<PersonnelOption[]> => {
        // Return current personnel if no input value
        if (!inputValue || inputValue.trim().length === 0) {
            if (defaultOption) {
                if (Array.isArray(defaultOption)) {
                    return defaultOption;
                }
                return [defaultOption];
            }
            return [];
        }

        // Return cached results if available
        if (cache[inputValue]) {
            return cache[inputValue];
        }

        // Fetch personnel from API
        try {
            const res = await fetch(`/api/searchpersonnel`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    searchfor: inputValue,
                }),
            });

            if (!res.ok) {
                console.error("Personnel search failed:", res.statusText);
                return [];
            }

            const data: SearchPersonnelResponse = await res.json();
            const options: PersonnelOption[] = data?.personnelOptions ?? [];

            // Cache the results
            cache[inputValue] = options;

            return options;
        } catch (error) {
            console.error("Personnel search error:", error);
            return [];
        }
    };
};